<div class="fs-2 with-close" mat-dialog-title>
    <ng-container *ngIf="mode == 'save' || mode == 'create'">Sauvegarder cette annonce</ng-container>
    <ng-container *ngIf="mode == 'move'" >Déplacer ce favoris</ng-container>
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <form (ngSubmit)="onYesClick()" [formGroup]="favoriteForm">
        <mat-form-field class="mt-3 pb-0">
            <mat-label>Séléctionner une liste</mat-label>
            <mat-select disableOptionCentering formControlName="list">
                <mat-option *ngFor="let l of lists" value="{{l.id}}">
                    <ng-container *ngIf="l.user_id != user.id">👥 -</ng-container>
                    {{l.title}}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <h4 class="text-center">Ou</h4>
        <mat-form-field>
            <mat-label>Créer un nouvelle liste</mat-label>
            <input formControlName="title" matInput class="text">
        </mat-form-field>
    </form>
</div>
<div mat-dialog-actions>
    <button (click)="onNoClick()" type="reset" class="btn btn-outline">
        Annuler
    </button>
    <button (click)="onYesClick()" type="submit" class="btn btn-primary">
        <mat-spinner diameter="26" *ngIf="loading"></mat-spinner>
        <ng-container *ngIf="!loading">Valider</ng-container>
    </button>
</div>
